import { Component, ChangeDetectionStrategy } from "@angular/core";

import { IlokBaseComponent } from "@mypxplat/xplat/features";
import { UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-ilok",
  templateUrl: "ilok.component.html",
  standalone: false,
})
export class IlokComponent extends IlokBaseComponent {
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }
}
